import { render, staticRenderFns } from "./t-card.vue?vue&type=template&id=b5990344"
import script from "./t-card.vue?vue&type=script&lang=js"
export * from "./t-card.vue?vue&type=script&lang=js"
import style0 from "./t-card.vue?vue&type=style&index=0&id=b5990344&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports